export const CONFIG_VALUE_FETCH_LIST_BY_DEVICE = "CONFIG_VALUE_FETCH_LIST_BY_DEVICE";
export const CONFIG_VALUE_FETCH_LIST_BY_DEVICE_SUCCESS = "CONFIG_VALUE_FETCH_LIST_BY_DEVICE_SUCCESS";